(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProyectosAprobadosPorPerfilModalidadController', ProyectosAprobadosPorPerfilModalidadController);

    ProyectosAprobadosPorPerfilModalidadController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function ProyectosAprobadosPorPerfilModalidadController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });
        
        sSAmbitos.$promise.then(function(sSAmbitos) {
        	vm.sSAmbitos = sSAmbitos;
            vm.selectedSSAmbito = sSAmbitos[0];
        });
        
        vm.centrosDocentes = centrosDocentes;
        
        programasEducativos.$promise.then(function(programaEducativos) {
          	vm.programasEducativos = programaEducativos;
          	vm.selectedProgramaEducativo = programaEducativos[0];
        });
             
    	vm.sSEstatusProyecto = sSEstatusProyecto;       	
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.proyectosAprobadosPorPerfilModalidad(
                    vm.selectedSSPeriodo.id,
                    vm.selectedSSAmbito,
                    vm.selectedProgramaEducativo.id
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();
